import HttpService from "common/http/httpService";
import PageFilter from "./pageFilter";
import ReturnsNullOn404 from "common/http/returnsNullOn404";
import ThrowsValidationError from "common/http/throwsValidationError";

class PageFilterService extends HttpService {

    @ReturnsNullOn404()
    async getPageFilter(pageName?: string): Promise<PageFilter> {
        const response = await this.getClient().get<PageFilter>('/settings/v1/user-preferences/page-filter', {
            params: {
                pageName
            }
        });
        return response.data;
    }

    @ThrowsValidationError()
    async updatePageFilter(pageFilter: PageFilter, pageName?: string): Promise<any> {
        const request = {
            ...pageFilter,
            pageName
        }
        await this.getClient().put('/settings/v1/user-preferences/page-filter', request);
    }
	
}

const pageFilterService = new PageFilterService();
export default pageFilterService;
